import { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({
  className = '',
  localeVariants = null,
  compact = false,
  sourceLanguage = null,
  sourceSlug = '',
}) => {
  const { currentLang, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const languages = [
    { code: 'sk', label: 'SK', fullName: 'Slovenčina' },
    { code: 'en', label: 'EN', fullName: 'English' },
    { code: 'pl', label: 'PL', fullName: 'Polski' },
    { code: 'cs', label: 'CS', fullName: 'Čeština' },
  ];
  const availableLanguages = localeVariants
    ? languages.filter((language) => language.code === currentLang || language.code === sourceLanguage || localeVariants.some((variant) => variant.language === language.code && variant.status === 'approved' && variant.indexable !== false && Boolean(variant.slug?.current || variant.slug)))
    : languages;
  const currentLanguage = languages.find((lang) => lang.code === currentLang);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
    };
    if (isOpen) document.addEventListener('pointerdown', handleClickOutside);
    return () => document.removeEventListener('pointerdown', handleClickOutside);
  }, [isOpen]);

  const handleLanguageChange = (langCode) => {
    if (langCode !== currentLang) {
      changeLanguage(langCode, ...(localeVariants ? [{ localeVariants, sourceLanguage, sourceSlug }] : []));
    }
    setIsOpen(false);
  };

  return (
    <div className={`language-switcher ${compact ? 'language-switcher-compact' : ''} ${className}`} ref={dropdownRef}>
      <button className='language-switcher-button' onClick={() => setIsOpen(!isOpen)} aria-label='Change language' aria-expanded={isOpen}>
        <span className={compact ? 'language-name' : 'language-code'}>{compact ? currentLanguage?.fullName : currentLanguage?.label}</span>
        <svg className={`chevron ${isOpen ? 'open' : ''}`} width='8' height='6' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L6 6L11 1' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' /></svg>
      </button>
      {isOpen && <div className='language-dropdown'>{availableLanguages.map((language) => <button key={language.code} className={`language-option ${currentLang === language.code ? 'active' : ''}`} onClick={() => handleLanguageChange(language.code)} aria-label={`${language.label} ${language.fullName}`} aria-current={currentLang === language.code ? 'true' : undefined}><span className='language-label'>{compact ? language.fullName : language.label}</span>{compact && <span className='language-name'>{language.label}</span>}</button>)}</div>}
    </div>
  );
};

export default LanguageSwitcher;
